import { Type } from '@sinclair/typebox';
import { PoolSchemaExtended } from '../pool/pool-extended.js';
import { SupportedNetworkSchema } from '../supported-network.js';
import { TradeLimitOrderSchema } from './limit-order.js';
var TradeBotSwapType;
(function (TradeBotSwapType) {
    TradeBotSwapType["Buy"] = "buy";
    TradeBotSwapType["Sell"] = "sell";
})(TradeBotSwapType || (TradeBotSwapType = {}));
const UserPositionSwapType = Type.Enum(TradeBotSwapType, {
    description: 'Swap Type',
    type: 'string',
    enum: ['buy', 'sell'],
});
const UserPositionPnlInfo = Type.Object({
    pnlNative: Type.String(),
    pnlUsd: Type.String(),
    pnlPercent: Type.String(),
});
export const UserPositionPriceInfo = Type.Object({
    priceNative: Type.String(),
    priceUsd: Type.String(),
    marketCap: Type.String(),
});
export const UserPositionSchema = Type.Object({
    id: Type.String(),
    pair: PoolSchemaExtended,
    network: SupportedNetworkSchema,
    hidden: Type.Boolean(),
    walletId: Type.String(),
    walletAddress: Type.String(),
    boughtSizeUSD: Type.String(),
    boughtSizeNative: Type.String(),
    boughtSizeTokens: Type.String(),
    boughtTransactions: Type.Number(),
    soldSizeUSD: Type.String(),
    soldSizeNative: Type.String(),
    soldSizeTokens: Type.String(),
    soldTransactions: Type.Number(),
    remainingSizeUSD: Type.String(),
    remainingSizeNative: Type.String(),
    remainingSizeTokens: Type.String(),
    entryPrice: UserPositionPriceInfo,
    targetPrice: Type.Optional(UserPositionPriceInfo),
    closePrice: Type.Optional(UserPositionPriceInfo),
    sellLimitOrder: Type.Optional(TradeLimitOrderSchema),
    pnl: UserPositionPnlInfo,
    enterTxnHash: Type.String(),
    closeTxnHash: Type.Optional(Type.String()),
    monthChart: Type.Array(Type.Object({
        timestamp: Type.String(),
        price: Type.String(),
        swaps: Type.Array(Type.Object({
            type: UserPositionSwapType,
            amount: Type.String(),
            timestamp: Type.String(),
        })),
    })),
    createdAt: Type.String(),
    updatedAt: Type.String(),
    closedAt: Type.Optional(Type.String()),
});
export const UserPositionAggregateSchema = Type.Object({
    boughtSizeUSD: Type.String(),
    boughtSizeNative: Type.String(),
    boughtSizeTokens: Type.String(),
    boughtTransactions: Type.Number(),
    soldSizeUSD: Type.String(),
    soldSizeNative: Type.String(),
    soldSizeTokens: Type.String(),
    soldTransactions: Type.Number(),
    remainingSizeUSD: Type.String(),
    remainingSizeNative: Type.String(),
    remainingSizeTokens: Type.String(),
    pnl: UserPositionPnlInfo,
    entryPrice: UserPositionPriceInfo,
    closePrice: Type.Optional(UserPositionPriceInfo),
    firstCreatedAt: Type.String(),
    lastUpdatedAt: Type.String(),
});
export const UserPositionByWalletSchema = Type.Object({
    walletId: Type.String(),
    walletAddress: Type.String(),
    position: UserPositionSchema,
});
const MonthChartSchema = Type.Array(Type.Object({
    timestamp: Type.String(),
    price: Type.String(),
    swaps: Type.Array(Type.Object({
        type: UserPositionSwapType,
        amount: Type.String(),
        timestamp: Type.String(),
    })),
}));
export const UserPositionByPoolSchema = Type.Object({
    poolAddress: Type.String(),
    token: Type.String(),
    pair: PoolSchemaExtended,
    network: SupportedNetworkSchema,
    aggregate: UserPositionAggregateSchema,
    monthChart: MonthChartSchema,
    positionsByWallet: Type.Array(UserPositionByWalletSchema),
});
export const FLAT_NUMERIC_STRING_FIELDS = [
    'boughtSizeUSD',
    'boughtSizeNative',
    'boughtSizeTokens',
    'soldSizeUSD',
    'soldSizeNative',
    'soldSizeTokens',
    'remainingSizeUSD',
    'remainingSizeNative',
    'remainingSizeTokens',
];
export const NESTED_NUMERIC_STRING_FIELDS = [
    'pnl.pnlNative',
    'pnl.pnlUsd',
];
export const UserPositionLightSchema = Type.Intersect([
    Type.Omit(UserPositionSchema, ['monthChart', 'pair']),
    Type.Object({
        pair: Type.String(),
    }),
]);
//# sourceMappingURL=position.js.map